import { Tabs, Tab as MuiTab, ThemeProvider, createTheme } from "@mui/material"
import classnames from "classnames"

import { colorTokens } from "@/components/colorTokens"
import Chip from "@/components/chip/Chip"
import { TabProps } from "@/types/components/tab"
import "./tab.scss"

export default function Tab({ type, list, value, onChange, ...props }: TabProps) {
  const mergedClassName = (itemValue: string | number, itemDisabled?: boolean) =>
    classnames({
      "tab-selected": itemValue === value,
      disabled: itemDisabled,
    })

  if (type === "line") {
    const customTheme = createTheme({
      palette: {
        primary: {
          main: colorTokens.text["grey-primary"],
        },
      },
    })

    return (
      <ThemeProvider theme={customTheme}>
        <Tabs value={value} onChange={onChange} {...props}>
          {list.map((item) => (
            <MuiTab
              key={item.value}
              label={item.label}
              value={item.value}
              disabled={item.disabled}
              icon={
                item.icon !== undefined ? (
                  <Chip type="number" label={item.icon.toString()} />
                ) : undefined
              }
              iconPosition="end"
              sx={{
                textTransform: "none", // 기본적으로 들어있는 upper case 제거
              }}
            />
          ))}
        </Tabs>
      </ThemeProvider>
    )
  }

  return (
    <div className={`TabCont ${type}`}>
      {list.map((item) => (
        <div
          key={item.value}
          className={mergedClassName(item.value, item.disabled)}
          onClick={(e) => onChange(e, item.value)}>
          {item.label}
          {type === "filled-desc" && <p>{item.description}</p>}
        </div>
      ))}
    </div>
  )
}
